import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./Navbar.module.css";
import {
  FaUserCircle,
  FaShoppingCart,
  FaPhone,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import Logo from "../../assets/images/logo.png";
import { useForm } from "../../context/FormContext";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navbarRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const { openForm } = useForm();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleScroll = () => {
      if (navbarRef.current) {
        const sticky = navbarRef.current.offsetTop;
        const scrollPosition = window.pageYOffset;
        setIsScrolled(isMobile || scrollPosition > sticky);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  const handleDemoClick = () => {
    openForm();
    setIsMobileMenuOpen(false);
  };

  const handleReachOut = (e) => {
    e.preventDefault();
    openForm();
    setIsMobileMenuOpen(false);
  };

  const handleScrollToFooter = () => {
    const footerElement = document.getElementById("footer"); // Ensure your footer has this ID
    footerElement?.scrollIntoView({ behavior: "smooth" });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      document.body.classList.add('menuOpen');
    } else {
      document.body.classList.remove('menuOpen');
    }
  };

  // Clean up body class when component unmounts
  useEffect(() => {
    return () => {
      document.body.classList.remove('menuOpen');
    };
  }, []);

  return (
    <header
      ref={navbarRef}
      className={`${styles.header} ${isScrolled ? styles.scrolled : ""} ${
        isMobile ? styles.mobileSticky : ""
      }`}
    >
      <div className={styles.topBar}>
        {!isMobileMenuOpen && (
          <Link to="/" className={styles.logoWrapper}>
            <img src={Logo} alt="StemXLogo" className={styles.logo} />
          </Link>
        )}
        <div className={styles.topBarLinks}>
          <button className={styles.demoButton} onClick={handleDemoClick}>
            Demo For Schools
          </button>
          {!isMobile && (
            <>
              <Link to="/products" className={styles.iconLink}>
                <FaShoppingCart /> Shop
              </Link>
              <Link to="#" className={styles.iconLink} onClick={handleReachOut}>
                <FaPhone /> Reach Out to Us
              </Link>
            </>
          )}
        </div>
        <button
          ref={mobileMenuRef}
          className={`${styles.hamburger} ${
            isScrolled ? styles.sticky_mobile : ""
          }`}
          onClick={toggleMobileMenu}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <div
        className={`${styles.mobileMenuWrapper} ${
          isMobileMenuOpen ? styles.open : ""
        }`}
      >
        <nav className={styles.mainNav}>
          {isMobileMenuOpen && (
            <div className={styles.mobileHeader}>
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                <img src={Logo} alt="StemX Logo" className={styles.mobileLogo} />
              </Link>
            </div>
          )}
          <ul className={styles.navLinks}>
            <li>
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/products" onClick={() => setIsMobileMenuOpen(false)}>
                LE<sup className={styles.superscript}>ts</sup>GO Store
              </Link>
            </li>
            <li>
              <Link
                to="/school-programmes"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                School Programmes
              </Link>
            </li>
            <li>
              <Link
                to="/robotics-ai"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Robotics & AI Competitions
              </Link>
            </li>
            <li>
              <Link
                to="/become-channel-partner"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Become a Channel Partner
              </Link>
            </li>
            <li>
              <Link
                to="/online-programs"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Online Programs
              </Link>
            </li>
            <li>
              <Link
                to="/appprivacypolicy"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                BuddyX Privacy Policy
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
